<script setup>
import CFIcon from '@/ui/Icon/CFIcon.vue';
import CFButton from '@/ui/Button/CFButton.vue';

defineProps({
    certificate: {
        type: Object,
        required: true,
    },
    selectedCertificate: {
        type: [Object, null],
        required: true,
    },
});

const emit = defineEmits(['select']);
</script>

<template>
    <div class="flex items-center gap-4 border-b border-black py-4">
        <span
            class="flex size-4 shrink-0 items-center justify-center rounded-full"
            :class="[selectedCertificate === certificate ? 'bg-accent' : 'bg-neutrals-400']"
        >
            <CFIcon
                v-show="selectedCertificate === certificate"
                name="arrow-right"
                class="size-3 text-white"
            />
        </span>
        <span class="grow underline underline-offset-3 select-none">
            {{ certificate.attributes.subject_name }}
        </span>
        <CFButton
            type="button"
            size="sm"
            class="shrink-0"
            :color="selectedCertificate === certificate ? 'accent' : 'primary'"
            :icon="selectedCertificate === certificate ? 'check' : null"
            :outline="selectedCertificate !== certificate"
            @click="emit('select')"
        >
            <span v-if="selectedCertificate !== certificate">{{ $t('button.select') }}</span>
            <span v-else>{{ $t('button.selected') }}</span>
        </CFButton>
    </div>
</template>
